<template>
  <section>
    <el-header class="d-flex align-items-center justify-content-between" style="background-color: #fff;">
      <el-badge v-if="currentChat" :value="unreadMessageTotal" :max="99" class="item" :hidden="unreadMessageTotal == 0">
        <el-button class="d-md-none" type="primary" circle @click="drawerLeft = true" icon="fas fa-user-friends"></el-button>
      </el-badge>
      <div class="d-flex w-100 justify-content-end">
        <el-button type="primary" circle icon="fas fa-sync" @click="reloadChat()"></el-button>
        <el-button type="primary" circle icon="fas fa-sign-out-alt" @click="logout()"></el-button>
      </div>
    </el-header>
    <el-drawer
      :with-header="true"
      :visible.sync="drawerLeft"
      direction="ltr"
      size="100%">
      <el-container class="chat" style="border: 1px solid #eee">
        <el-aside class="chat-availability" width="100%" style="background-color: #f9f9f9;">
          <el-collapse  v-model="activeGroup" @change="handleChange">
            <el-collapse-item title="Online Team Members" name="1">
              <div @click="setCurrentChat(user)" class="chat-user" style="padding: 0.5rem;" v-for="(user, index) in usersOnline" :key="index">
                <el-badge :value="unreadMessageCount[user.id]" :max="99" class="item" :hidden="unreadMessageCount[user.id] == 0">
                  <el-avatar :src="_.get(user, 'avatar', null)"  :style="`background:${getColour(user.full_name)}`">{{ getInitials(user.full_name)}}</el-avatar>
                </el-badge>
                <span>{{user.full_name}}</span>
              </div>
            </el-collapse-item>
            <el-collapse-item title="Offline Team Members" name="2">
              <div @click="setCurrentChat(offline)" class="chat-user" style="padding: 0.5rem;" v-for="(offline, index) in usersOffline" :key="index">
                <el-badge :value="unreadMessageCount[offline.id]" :max="99" class="item" :hidden="unreadMessageCount[offline.id] == 0">
                  <el-avatar :src="_.get(offline, 'avatar', null)" :style="`background:${getColour(offline.full_name)}`">{{ getInitials(offline.full_name)}}</el-avatar>
                </el-badge>
                <span>{{offline.full_name}}</span>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-aside>
      </el-container>
    </el-drawer>
    <el-container v-if="!currentChat" class="chat d-md-none" style="border: 1px solid #eee">
      <el-aside class="chat-availability d-block d-md-none" width="100%" style="background-color: #f9f9f9;">
        <el-collapse  v-model="activeGroup" @change="handleChange">
          <el-collapse-item title="Online Team Members" name="1">
            <div @click="setCurrentChat(user)" class="chat-user" style="padding: 0.5rem;" v-for="(user, index) in usersOnline" :key="index">
              <el-badge :value="unreadMessageCount[user.id]" :max="99" class="item" :hidden="unreadMessageCount[user.id] == 0">
                <el-avatar :src="_.get(user, 'avatar', null)" :style="`background:${getColour(user.full_name)}`">{{ getInitials(user.full_name)}}</el-avatar>
              </el-badge>
              <span>{{user.full_name}}</span>
            </div>
          </el-collapse-item>
          <el-collapse-item title="Offline Team Members" name="2">
            <div @click="setCurrentChat(offline)" class="chat-user" style="padding: 0.5rem;" v-for="(offline, index) in usersOffline" :key="index">
              <el-badge :value="unreadMessageCount[offline.id]" :max="99" class="item" :hidden="unreadMessageCount[offline.id] == 0">
                <el-avatar :src="_.get(offline, 'avatar', null)"  :style="`background:${getColour(offline.full_name)}`">{{ getInitials(offline.full_name)}}</el-avatar>
              </el-badge>
              <span>{{offline.full_name}}</span>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-aside>
    </el-container>
    <el-container class="chat" style="border: 1px solid #eee" :class="{'d-none d-md-flex': !currentChat}">
      <el-aside class="chat-availability d-none d-md-block" width="100%" style="background-color: #f9f9f9;">
        <el-collapse  v-model="activeGroup" @change="handleChange">
          <el-collapse-item title="Online Team Members" name="1">
            <div @click="setCurrentChat(user)" class="chat-user" style="padding: 0.5rem;" v-for="(user, index) in usersOnline" :key="index">
              <el-badge :value="unreadMessageCount[user.id]" :max="99" class="item" :hidden="unreadMessageCount[user.id] == 0">
                <el-avatar :src="_.get(user, 'avatar', null)"  :style="`background:${getColour(user.full_name)}`">{{ getInitials(user.full_name)}}</el-avatar>
              </el-badge>
              <span>{{user.full_name}}</span>
            </div>
          </el-collapse-item>
          <el-collapse-item title="Offline Team Members" name="2">
            <div @click="setCurrentChat(offline)" class="chat-user" style="padding: 0.5rem;" v-for="(offline, index) in usersOffline" :key="index">
              <el-badge :value="unreadMessageCount[offline.id]" :max="99" class="item" :hidden="unreadMessageCount[offline.id] == 0">
                <el-avatar :src="_.get(offline, 'avatar', null)"  :style="`background:${getColour(offline.full_name)}`">{{ getInitials(offline.full_name)}}</el-avatar>
              </el-badge>
              <span>{{offline.full_name}}</span>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-aside>
        <el-container v-if="currentChat" :key="currentChat.id" class="chat-container">
          <el-header class="chat-header">
            <span class="chat-title">
              <i :class="typing ? 'el-icon-chat-dot-round' : 'el-icon-chat-round'"></i>
              {{currentChat.full_name}}
            </span>
          </el-header>
          <el-main style="flex-direction: column;">
            <div class="row w-100 chat-window" ref="chat_board">
              <infinite-loading
                :identified="`chat-app-${currentChat.id}`"
                @infinite="infiniteHandler"
                spinner="spiral"
                direction="top"
              >
                <div slot="no-more"></div>
                <div slot="no-results"></div>
              </infinite-loading>
              <div
                v-for="(msg, index) in messages"
                :key="index"
                class="col-12"
              >
                <div class="row">
                  <div class="col-12 text-center"><small>{{ msg.created_at +'Z' | moment('from', 'now')}}</small></div>
                  <div :class="`col-12 justify-content-${myself.id == msg.sender_id ? 'end' : 'start'} d-flex`">
                    <div :class="`message ${myself.id == msg.sender_id ? 'self' : 'other'}`">
                      <Message :message="msg.message" :message-id="index"></Message>
                    </div>
                  </div>
                  <div :class="`col-12 justify-content-${myself.id == msg.sender_id ? 'end' : 'start'} d-flex`">
                    <small>{{myself.id == msg.sender_id ? myself.full_name : currentChat.full_name}}</small>
                  </div>
                </div>
              </div>
            </div>
          </el-main>
          <el-footer>
            <el-input
              type="textarea"
              :rows="3"
              :autofocus="true"
              :autosize="{ minRows: 3, maxRows: 3 }"
              placeholder="Type something"
              v-model="message"
              @keypress.enter.native="sendMessage"
              @keydown.native="isTyping">
            </el-input>
            <small v-show="typing">{{ whosTyping }} is typing...</small>
          </el-footer>
        </el-container>
    </el-container>
  </section>
</template>

<script>
import { mapGetters, mapState, mapMutations } from "vuex"
import InfiniteLoading from "vue-infinite-loading";
import ChatSlideOutPanel from "./ChatSlideOutPanel.vue";
import Message from "./Message.vue"

export default {
  name: 'TenantChatContainerPwa',
  components: {
    ChatSlideOutPanel,
    InfiniteLoading,
    Message
  },
  props: {
  },
  data() {
     return {
      drawerLeft: false,
      visible: true,
      message: "",
      page: 0,
      activeGroup: ['1'],
      currentChat: null,
      typing: false,
      whosTyping: '',
      messages: [],
      incomingMessage: false,
      documentTitle: document.title
    };
  },
  created(){
    Echo.private('tenant_app_messaging.' + this.tenant + "." + this.myself.id)
      .listen('.global.message', (e) => {
        if (e.appMessage.sender_id !== this.myself.id) {

            if (this.visible) {
              if (!_.isEmpty(this.currentChat) && this.currentChat.id != e.appMessage.sender_id) {
                let sender = this.unreadMessageCount[e.appMessage.sender_id];
                this.$store.dispatch("chat/setUnreadMessageCount", {id: e.appMessage.sender_id, count: !sender ? 1 : sender += 1});
              } else if (_.isEmpty(this.currentChat)){
                let sender = this.unreadMessageCount[e.appMessage.sender_id];
                this.$store.dispatch("chat/setUnreadMessageCount", {id: e.appMessage.sender_id, count: !sender ? 1 : sender += 1});
              } else {
                this.messages.push(e.appMessage);

                this.$nextTick(() => {
                  this.$refs.chat_board.scrollTop = this.$refs.chat_board.scrollHeight;
                });
                this.$store.dispatch("chat/setUnreadMessageCount", {id: e.appMessage.sender_id, count: 0});
              }
            } else {
                this.incomingMessage = true;
                let sender = this.unreadMessageCount[e.appMessage.sender_id];
                this.$store.dispatch("chat/setUnreadMessageCount", {id: e.appMessage.sender_id, count: !sender ? 1 : sender += 1});
            }

            this.updateMessageCount();

            Notification.requestPermission( permission => {
              if (!this.chatVisible) {
                let length = 50;
                let trimmedString = e.appMessage.message.length > length ?
                      e.appMessage.message.substring(0, length - 3) + "..." :
                      e.appMessage.message;
                let notification = new Notification('New Ambition Message', {
                  body: trimmedString,
                  icon: "https://ambitioncloud.s3-ap-southeast-2.amazonaws.com/logo.png"
                });

                notification.onclick = () => {
                  // window.open(window.location.href);
                };
              }
            });
        }
      })
      .listenForWhisper('typing', (e) => {
        this.whosTyping = e.user;
        this.typing = e.typing;

        // remove is typing indicator after 0.9s
        setTimeout(() => {
          this.typing = false
        }, 3000);
      })
      .listenForWhisper('update.message.total', (e) => {
        this.$store.dispatch("chat/setUnreadMessageCount", {id: e.id, count: 0});
      });
  },
  computed: {
    ...mapGetters({
      tenant: "chat/tenant",
      usersOnline: "chat/usersOnline",
      unreadMessageTotal: "chat/unreadMessageTotal",
      myself: "chat/myself",
      usersOffline: "chat/getOfflineMembers",
      unreadMessageCount: "chat/unreadMessageCount",
      chatVisible: "chat/chatVisible"
    }),
    messageStatus() {
      return this.incomingMessage ? 'New chat message....' : this.documentTitle;
    },

  },
  watch: {
    messageStatus(newVal, oldVal) {
      if (this.incomingMessage) {
        this.incomingMessage = false;
        document.title = newVal

        setTimeout(() => {
          document.title = this.messageStatus;
        }, 5000);
      }
    }
  },
  mounted() {
    this.$store.dispatch('global commit', { type: 'chat/setChatVisible', payload: true });
    document.addEventListener("visibilitychange", () => {
      this.$store.dispatch('global commit', { type: 'chat/setChatVisible', payload: !document.hidden });
    });
  },
  updated() {
  },
  activated() {
  },
  methods: {
    reloadChat() {
      location.reload();
    },

    logout() {
      const getUrl = window.location;
      let logoutPath = getUrl.protocol + "//" + getUrl.host + "/logout";
      window.location.href = logoutPath;
    },

    getInitials(name) {
      return name.split(" ").map((e) => e.charAt(0)).join("").toUpperCase();
    },

    getColour(username, s=30, l=50) {
      var hash = 0;
      for (var i = 0; i < username.length; i++) {
        hash = username.charCodeAt(i) + ((hash << 5) - hash);
      }

      var h = hash % 360;
      return 'hsl('+h+', '+s+'%, '+l+'%)';
    },

    setCurrentChat(user) {
      if (_.isEmpty(this.currentChat) || user.id != this.currentChat.id) {
        let channel = Echo.private('tenant_app_messaging.' + this.tenant + "." + this.myself.id);
        this.drawerLeft = false;
        this.page = 1;
        this.messages = [];
        this.currentChat = user;
        this.$store.dispatch("chat/setUnreadMessageCount", {id: user.id, count: 0});
        channel.whisper('update.message.total', {id: user.id, count: 0});
        this.updateMessageCount();
        this.$bus.$emit('toggle-private-message', true);
      }
    },

    async sendMessage() {
      if (this.message.trim()) {
        try {
          this.messages.push({
            message: this.message.trim(),
            created_at: this.$moment(new Date())
              .utc()
              .format("YYYY-MM-DD HH:mm:ss"),
            user: this.myself,
            sender_id: this.myself.id,
            participant: this.currentChat
          });

          this.$nextTick(() => {
            this.$refs.chat_board.scrollTop = this.$refs.chat_board.scrollHeight;
          });
          let res = await axios.post(
            `/api/v2/global-messaging`,
            {
              message: this.message,
              participant: this.currentChat.id,
              user: this.myself.id
            },
            {
              headers: {
                Authorization: `Bearer ${this.$store.getters.token}`
              }
            }
          );
          this.message = "";
        } catch (err) {
          console.error(err);
          this.$message({
            message: "Error Sending Message",
            type: "error"
          });
        }
      }
    },

    async updateMessageCount() {
      try {
        let res = await axios.post(
          `/api/v2/global-messaging-count/${this.myself.id}`,
          {
            count: this.unreadMessageCount,
          },
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`
            }
          }
        );
      } catch (err) {
        console.error(err);
      }
    },

    infiniteHandler: _.throttle(async function($state) {
      try {
        let messages = await this.getMessages();
        if (messages.length) {
          if (this.messages.length) {
            this.messages.unshift(...messages);
          } else {
            this.messages = messages;
            this.$nextTick(() => {
              this.$refs.chat_board.scrollTop = this.$refs.chat_board.scrollHeight;
            });
          }

          this.page++;
          $state.loaded();
        } else {
          $state.complete();
        }
      } catch (Err) {
        console.error(Err);
        $state.error();
      }
    }, 500),

    async getMessages() {
      return new Promise(async (resolve, reject) => {
        try {
          let res = await axios.get(
            `/api/v2/global-messaging`,
            {
              headers: {
                Authorization: `Bearer ${this.$store.getters.token}`
              },
              params: {
                page: this.page,
                participant: this.currentChat.id,
                user: this.myself.id
              }
            }
          );
          resolve(res.data.data.reverse());
        } catch (err) {
          console.error(err);
          reject(err);
        }
      });
    },

    handleChange(val) {

    },

    isTyping() {
      let channel = Echo.private('tenant_app_messaging.' + this.tenant + "." + this.currentChat.id);

      setTimeout(() => {
        channel.whisper('typing', {
          user: this.myself.first_name,
          typing: true
        });
      }, 5000);
    },

    onClose(param) {
        this.messages = [];
        this.$bus.$emit('toggle-tenant-messaging', false);
        this.currentChat = null;
    }
  }
}
</script>

<style lang="scss" scoped>
  .chat-availability {
    @media (min-width: 768px) {
      max-width: 300px !important;
    }
  }

  .chat {
    height: calc(100vh - 60px);
    // @media (min-width: 768px) {
    //   height: 100vh;
    // }
  }
</style>

<style lang="scss">
  .chat-slideout {
    .el-collapse-item__wrap {
      padding: 0.5rem;

      .chat-user {
        display: flex;
        align-items: center;
        span {
          margin-left: 1rem;
        }

        &:hover {
          cursor: pointer;
          background: #2689df;
          color: #fff;
          border-radius: 1rem;
          transition: 200ms background ease-in-out;
        }
      }
    }

    .blackout {
      display: none !important;
    }
    .dock {
      max-width: 100% !important;
    }

    .action-close {
      height: 32px;
    }

    .chat-availability {
      &::-webkit-scrollbar {
        display:none;
      }
      -ms-overflow-style: none;  /* IE and Edge */
      scrollbar-width: none;  /* Firefox */
      .el-collapse-item__header {
        padding-left: 0.5rem !important;
      }

      .el-collapse {
        .el-collapse-item__wrap {
          background: #f9f9f9;
        }
      }
    }
    .chat-container {
      width: 600px;
      max-width: 100% !important;
    }
    .chat-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      text-align: right;
      font-size: 12px;
      padding-right: 40px;
      background: #2689e0;
      color: #fff;

      .chat-title {
        display: flex;
        align-items: center;

        i {
          font-size: 1.5rem;
          margin-right: 1rem;
        }
      }
      .el-icon-setting {
        color: #fff;
      }
    }
    .chat-window {
      &::-webkit-scrollbar {
        display:none;
      }
      -ms-overflow-style: none;  /* IE and Edge */
      scrollbar-width: none;  /* Firefox */
    }
    .el-footer {
      height: 100px !important;

      textarea {
        resize: none !important;
        box-shadow: none !important
      }
    }

    .infinite-loading-container {
      min-width: 100%;
      // display: flex;
      // align-items: center;
      // justify-content: center;
      text-align: center;
    }

  }
</style>
